
//Ajax Integration on payment page
export function authorizeCreditCard(baseUrl, authorizePayload) {

    var cc = authorizePayload.cardNumber;
    var name = authorizePayload.name;
    var myData = $XIPlugin.createJSRequestPacket(authorizePayload.merchantGuid, authorizePayload.accessToken);

    myData.addField($XIPlugin.createField('PaymentCreditCard', true, cc));
    myData.addField($XIPlugin.createField('name', false, name));

    return new Promise((resolve, reject) => {
        $XIPlugin.ajax({
            url: baseUrl + '/ajax',
            type: "POST",
            data: myData,
            success: function (response) {
                resolve(response);
            },
            error: function (error) {
                reject(error);
            }
        });

    });
}


$(document).ready(function () {
    var input = document.querySelector('#CreditCardDate');
    if (input) {
        input.onkeypress = handleChange;
        function handleChange(e) {
            if (e.target.value.length == 2) {
                e.target.value = e.target.value.replace(/[\D]/g, '').replace(/(\d{2})/, "$1/");
            }
        }
    }
});